const OutgoingCallIdEnum = Object.freeze({
  Organisation: 'Organisation',
  Team: 'Team',
  LocalPresence: 'LocalPresence',
  Personal: 'Personal',
});

export default OutgoingCallIdEnum;
